//sweetalert2
window.Swal = require('sweetalert2');